export const matchesExtraFilters = (
  extras: string[],
  selectedExtras: string[]
): boolean => {
  if (selectedExtras.length === 0) return true
  return selectedExtras.every((selectedExtra) => extras.includes(selectedExtra))
}
